/**
 * Shopify Ajaxify Shop. 
 * 
 * @uses Modified Shopify jQuery API (link to it)
 *
 */
  var beforePrices = {};
  var afterPrices = {};

jQuery(document).ready(function() { 
//Begin Wrapper

var jQ = jQuery;

/**
 * Collection of Selectors for various pieces on the page we need to update 
 *
 * I've tried to keep these as general and flexible as possible, but 
 * if you are doing your own markup, you may find you need to change some of these.
 *
 */
var selectors = {
    // Any elements(s) with this selector will have the total item count put there on add to cart.
    TOTAL_ITEMS: '.cart-total-items', 
    TOTAL_PRICE: '.cart-total-price',

    SUBMIT_ADD_TO_CART: 'input[id=add]',
    
    FORM_ADD_TO_CART: "form[action='/cart/add']",
    
    FORM_UPDATE_CART: 'form[class=bagform]',
    //The actual Update Button
    FORM_UPDATE_CART_BUTTON: 'form[class=bagform] input[name=update]',
    //All the buttons on the form
    FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',

    LINE_ITEM_ROW: '.cart-line-item',
    LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
    LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',

    LINE_ITEM_REMOVE: '.remove a',
    
    EMPTY_CART_MESSAGE: '#empty'
};


/**
 * Collection of text strings. This is where you would change for a diff language, for example. 
 *
 */
var text = {
    ITEM: 'Item', 
    ITEMS: 'Items'
};

//Convenience method to format money. 
//Can just transform the amount here if needed
var formatMoney = function(price) {
    return Shopify.formatMoney(price , '$ {{ amount }}');
};


//Attach Submit Handler to all forms with the /cart/add action. 
jQ(selectors.FORM_ADD_TO_CART).submit(function(e) {
    e.preventDefault();
    //Disable the Add To Cart button, add a disabled class. 
    jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');

    //Can't use updateCartFromForm since you need the item added before you can update (otherwise, would have been more convenient)
    //So, in onItemAdded, we Shopify.getCart() to force the repaint of items in cart. 
    Shopify.addItemFromForm(e.target);
});
  
  

  
  function prePrices(form){
	var $rows = $(form).find('.cart-line-item');
   
    for (var i = 0; i < $rows.length; i++) {
      beforePrices[$($rows[i]).find('td:last p').attr('class')] = $($rows[i]).find('td:last p').html();
    }
    //console.log(beforePrices);
  }
  
  function postPrices(form){
    var $rows = $(form).find('.cart-line-item');
    
    for (var i = 0; i < $rows.length; i++) {
      afterPrices[$($rows[i]).find('td:last p').attr('class')] = $($rows[i]).find('td:last p').html();
    }
    //console.log(afterPrices);
    comparePrices();
  }
  
  function comparePrices(){
    var count = Object.keys(beforePrices).length;
    
    $.each(afterPrices, function(index, value) {
      if (afterPrices[index] !== beforePrices[index]){
        //console.log(afterPrices[index] +','+ beforePrices[index]);
        $('.' + index).parent().addClass('update');  
        setTimeout(function(){
          $('.' + index).parent().addClass('update').removeClass('update');
        }, 1000);
      }
      
    });
    
  }
  
  
//We only want to interrupt the UPDATE, not the CHECKOUT process
jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
    e.preventDefault();
  	// get current price values of each product
  	prePrices(e.target.form);
    jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
    Shopify.updateCartFromForm(e.target.form);
});
  


//Delegate the Remove Link functionality on the cart page.
jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
    e.preventDefault();
    //Get the variant ID from the URL
    var vid = this.href.split('/').pop().split('?').shift();
    Shopify.removeItem(vid);
    $('#cartform').find('select[id="sel_desktop_updates_' + vid + '"]').parents().closest('.cart-line-item').remove();
    $('#mobile-cartform').find('select[id="sel_updates_' + vid + '"]').parents().closest('.cart-line-item').next('.product-break').remove();
    $('#mobile-cartform').find('select[id="sel_updates_' + vid + '"]').parents().closest('.cart-line-item').remove();
    jQ(this).parents(selectors.LINE_ITEM_ROW).fadeOut(600, function() { $(this).remove(); });
});


/**
 * Shopify.onItemAdded
 * 
 * Triggered by the response when something is added to the cart via the add to cart button.
 * This is where you would want to put any flash messaging, for example.
 * 
 * @param object line_item
 * @param HTMLelement/String Form HTMLElement, or selector
 */
Shopify.onItemAdded = function(line_item, form) {
    //Default behaviour for this modification:
    //When a Add To Cart form is clicked, we disable the button and apply a class of disabled. 
    //Here is where we remove the disabled class, and reactivate the button.
    jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
  	
	// item to be added
  	var item_id = line_item.id;
    // if exact item not already in drawer, prepend
    if ($('.drawer-table').find('select[id="sel_desktop_updates_' + item_id + '"]').parents('.cart-line-item').is(':visible') === false) {
      prependProduct(line_item);
    // else if in drawer, update numbers
    } else {
      updateProduct(line_item);
    }
    // when drawer is empty but you add the same product without refreshing the page
    if (($('.drawer-table').is(":hidden") == true && $('.drawer-table').find('select[id="sel_desktop_updates_' + item_id + '"]').length > 0)) {
      $('#cartform').show();
    }
   
    function prependProduct(line_item) {
	  var item_id = line_item.id;
      var item_url = line_item.url;
      var item_img = line_item.image;
      var item_brand = line_item.vendor;
      var item_title = line_item.title;
      var item_line_price = line_item.price;
      var item_price = ('' + item_line_price).slice(0,-2);
      var item_quantity = line_item.quantity;
      var item_line_subtotal = line_item.line_price;
      var item_subtotal = ('' + item_line_subtotal).slice(0,-2);
      var html;
      var isEven;
      var remain = ($('.drawer-table tr').length) % 2;
      var drawer= $('.drawer-table');
      //console.log(line_item.properties['variant_quantity']);
      // row is given even or odd class
      if (remain == 0) {

        var html_string = '<tr class="cart-line-item even"><td><div class="cart-item"><div class="cart-image"><a href="' + item_url + '" title="' + item_title + '"><img src="' + item_img + '" alt="' + item_title + '"></a></div><div class="cart-title"><p>' + item_brand + '</p><p>' + item_title + '</p></div></div></td><td><p>$ ' + item_price + '.00' + '</p></td><td><select name="updates[' + item_id + ']" id="sel_desktop_updates_' + item_id + '" style="margin: 0 auto; width: 60px;">';
        if (parseInt(line_item.properties['variant_quantity']) > 10) {
          for(var i = 1; i <= 10; i++) {
            if(i === item_quantity) {
              html_string += '<option selected="selected" value="' + i + '">'+i+'</option>';
            } else {
              html_string += '<option value="' + i + '">'+i+'</option>';
            }
          }
        } else {
          for(var i = 1; i <= parseInt(line_item.properties['variant_quantity']); i++) {
            if(i === item_quantity) {
              html_string += '<option selected="selected" value="' + i + '">'+i+'</option>';
            } else {
              html_string += '<option value="' + i + '">'+i+'</option>';
            }
          }
        }
        html_string == '</select>';
        
        html_string += '</td><td style="text-align: center"><p class="remove"><a href="/products/' + item_id + '">X</a></p></td><td><p class="cart-line-item-price-' + item_id + '">$ ' + item_subtotal + '.00' + '</p></td></tr>';
        html = jQ(html_string);
      
      } else {
        var html_string = '<tr class="cart-line-item odd"><td><div class="cart-item"><div class="cart-image"><a href="' + item_url + '" title="' + item_title + '"><img src="' + item_img + '" alt="' + item_title + '"></a></div><div class="cart-title"><p>' + item_brand + '</p><p>' + item_title + '</p></div></div></td><td><p>$ ' + item_price + '.00' + '</p></td><td><select name="updates[' + item_id + ']" id="sel_desktop_updates_' + item_id + '" style="margin: 0 auto; width: 60px;">';
        if (parseInt(line_item.properties['variant_quantity']) > 10) {
          for(var i = 1; i <= 10; i++) {
            if(i === item_quantity) {
              html_string += '<option selected="selected" value="' + i + '">'+i+'</option>';
            } else {
              html_string += '<option value="' + i + '">'+i+'</option>';
            }
          }
        } else {
          for(var i = 1; i <= parseInt(line_item.properties['variant_quantity']); i++) {
            if(i === item_quantity) {
              html_string += '<option selected="selected" value="' + i + '">'+i+'</option>';
            } else {
              html_string += '<option value="' + i + '">'+i+'</option>';
            }
          }
        }
        html_string == '</select>';
        
        html_string += '</td><td style="text-align: center"><p class="remove"><a href="/products/' + item_id + '">X</a></p></td><td><p class="cart-line-item-price-' + item_id + '">$ ' + item_subtotal + '.00' + '</p></td></tr>';
        html = jQ(html_string);
      }
      
      // prepend row
      $(html).hide().prependTo(drawer).fadeIn(1200);
      //drawer.prepend(html);
    }
  
    function updateProduct(line_item){
      var item_id = line_item.id;
      var item_title = line_item.title;
      var new_line_subtotal = line_item.line_price;
      var line_subtotal_str = ('' + new_line_subtotal).slice(0,-2);
      var new_value = parseInt($('.drawer-table').find('.cart-title p:contains("' + item_title + '")').parents('.cart-line-item').find('option[selected]').val()) + 1;
      var string_value = '' + new_value;
      
      $('.drawer-table').find('select[id="sel_desktop_updates_' + item_id + '"]').find('option[selected]').removeAttr('selected');
      $('.drawer-table').find('select[id="sel_desktop_updates_' + item_id + '"]').find('option[value=' + string_value + ']').attr('selected', 'selected');
      $('.drawer-table').find('.cart-line-item-price-' + item_id).text('$ ' + line_subtotal_str + '.00');
      $('.drawer-table').find('.cart-line-item-price-' + item_id).parent().addClass('update');
      setTimeout(function(){
        $('.drawer-table').find('.cart-line-item-price-' + item_id).parent().removeClass('update');
      }, 1000);
    }
 
  
    //You can add any extra messaging you would want here.  
  	// added to cart message
  	jQ('#variant-inventory').hide();
  	jQ('.added-button').show();
    setTimeout(function(){
      jQ('.added-button').fadeOut(600);
    }, 1200);

    //Get the state of the cart, which will trigger onCartUpdate
    Shopify.getCart();
};

/**
 * This updates the N item/items left in your cart
 * 
 * It's setup to match the HTML used to display the Cart Count on Load. If you change that (in your theme.liquid) 
 * you will probably want to change the message html here. 
 * This will update the HTML in ANY element with the class defined in selectors.TOTAL_ITEMS
 *
 * @param object the cart object. 
 * @param HTMLElement form. If included, we know its an Update of the CART FORM, which will trigger additional behaviour. 
 */
Shopify.onCartUpdate = function(cart, form) {
  console.log('cart update');
  
    // Total Items Update
    var message = '<span class="count">'+cart.item_count+'</span>';
    jQ(selectors.TOTAL_ITEMS).hide().html(message).fadeIn(600);

    // Price update - any element matching the selector will have their contents updated with the cart price.
    var price = formatMoney(cart.total_price);
    jQ(selectors.TOTAL_PRICE).hide().html(price).fadeIn(1200);

    //If the EMPTY_CART_MESSAGE element exiss, we should show it, and hide the form. 
    if( (jQ(selectors.EMPTY_CART_MESSAGE).length > 0) &&  cart.item_count == 0) {
        jQ(selectors.FORM_UPDATE_CART).hide();
        jQ(selectors.EMPTY_CART_MESSAGE).show();
      	closeDrawer();
    }
  
  	// If cart is empty, close shopping cart drawer
    function closeDrawer() {
      jQ('#drawer').stop().slideUp();
      jQ('#drawer').removeClass('open');
    }
      
    jQ.each(cart.items, function(index, cartItem) {
      //console.log(cartItem.id);
    });
  
   	
  	// remove row with quantity input zero
  	var inputs = jQ('.cart-line-item td').find('input');
    jQ.each(inputs, function(k, v){
      var value = jQ(v).val();
      if (value == 0) {
        jQ(v).parent().parent().fadeOut(600, function() { $(this).remove(); });
      }
    });



    // A form was passed in?
    form = form || false;
    //so it's the cart page form update, trigger behaviours for that page
    if(form) {

        //Nothing left in cart, we reveal the Nothing in cart content, hide the form.
        if(cart.item_count > 0) {
            //Loops through cart items, update the prices.
            jQ.each(cart.items, function(index, cartItem) {
                jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(formatMoney(cartItem.line_price));
                jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
            });


            //And remove any line items with 0
            jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();
          	var new_subtotal = jQ(form).find('.cart-total-price').text();
          	jQ('.cart-total-price').stop().fadeOut().text(new_subtotal).fadeIn();

            //Since we are on the cart page, reenable the buttons we disabled
            jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');

        }    
        //You can add any extra messaging you would want here. 
        //successMessage('Cart Updated.');
	postPrices(form);
    }
  // cartform should always be showing so even if empty, products can still prepend to the table
  jQ('#cartform').css('display','block !important');
};


//What to display when there is an error. You tell me?! I've left in a commented out example.
// You can tie this in to any sort of flash messages, or lightbox, or whatnot you want.
Shopify.onError = function(XMLHttpRequest, textStatus) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  //Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  //errorMessage(data.message + '(' + data.status  + '): ' + data.description);
  if (data.status == 422) {
    $('#variant-inventory').text('You got the last one!').show();
  }

};

//End Wrapper    
});